import React, { useState, useEffect, useReducer }  from 'react';
import { Button, IconButton } from '@material-ui/core'
import './UserActionButtonGroup.scss'

export default function UserActionButtonGroup(props){
    const [isStateInit] = useState(false)

    const [id, setId] = useReducer((originalValue, newValue) => {
        return newValue
    }, '');

    function onViewClick(event){
        if(id){
            props.history.push('/admin/userdetails/view/' + id)
        }
    }

    function onEditClick(event){
        if(id){
            props.history.push('/admin/userdetails/edit/' + id)
        }
    }

    useEffect(() => {
        if(!isStateInit){
            setId(props.id)
        }
    }, [isStateInit, props.id])

    return (
        <div className='action-group'>
            <div className="view-icon" onClick={onViewClick}></div>
            {props.adminGroup === 'Admin' ? <div className="edit-icon" onClick={onEditClick}></div> : null}
        </div>
    )
}